import config from "./config_test";
import c from "./config_prod";

export default (process.env.REACT_APP_STAGE === "prod" ? c : config);
